import { useQuery } from 'react-query';
import qs from 'qs';

import { axios } from 'lib';

const defaultQueryParams = {
  page: 0,
  limit: 10,
  search: '',
  queryKey: ['dps-files'],
  queryOptions: {},
};

const getFiles = async (dpsID, queryStringParams) => {
  const queryString = qs.stringify({ ...queryStringParams });
  const {
    data: { data, total },
  } = await axios.get(`/api/dps/${dpsID}/files?${queryString}`);

  return { files: data || [], total };
};

export const useFiles = (dpsID, queryParams = {}) => {
  const { queryKey, queryOptions, limit, page, ...rest } = {
    ...defaultQueryParams,
    ...queryParams,
  };

  const queryStringParams = {
    limit,
    page,
    offset: page * limit,
    ...rest,
  };

  return useQuery([...queryKey, dpsID], () => getFiles(dpsID, queryStringParams), {
    initialData: { files: [], total: 0 },
    ...queryOptions,
  });
};
